import React from 'react';
import { connect } from 'react-redux';
import { withTranslation, WithTranslation } from 'react-i18next';
import { ApplicationState } from '../../store';
import { SettingsState } from '../../types/redux/SettingsTypes';

import SearchField from './SearchField';
import SearchResults from './SearchResults';

//component state
interface IStateProps {

}

//component props
interface IOwnProps {

}

//redux state props
interface IReduxStateProps {
    settings: SettingsState
}

interface IReduxDispatchProps {

}

type Props = IOwnProps & IReduxStateProps & IReduxDispatchProps & WithTranslation;

class Autocomplete extends React.PureComponent<Props, IStateProps> {

    render() {

        return <React.Fragment>
            <form className="navbar-form search-field" role="search" action={ this.props.settings.links.searchLink } >
                <SearchField />
            </form>
            <SearchResults />
        </React.Fragment>;
    }
}

const mapStateToProps = ( state: ApplicationState ): IReduxStateProps => ( {
    settings: state.settingsReducer
} );

const mapDispatchToProps = ( dispatch: Function ): IReduxDispatchProps => ( {

} );

export default connect<IReduxStateProps, IReduxDispatchProps, IOwnProps, ApplicationState>(
    mapStateToProps,
    mapDispatchToProps
)( withTranslation()( Autocomplete ) );

